import { createContext, useContext } from "react";

export const FeatureFlagContext = createContext();

export function useFeature() {
  return useContext(FeatureFlagContext);
}
